export type MediaObjectFit = "contain" | "cover";

export const DEFAULT_MEDIA_OBJECT_FIT: MediaObjectFit = "cover";

export const getMediaObjectFitFieldName = (fieldName: string) =>
  `${fieldName}ObjectFit`;

export const resolveMediaObjectFit = (value: unknown): MediaObjectFit => {
  if (value === "contain") {
    return value;
  }

  return DEFAULT_MEDIA_OBJECT_FIT;
};

export const mediaObjectFitClassName = (value: unknown) => {
  const objectFit = resolveMediaObjectFit(value);

  if (objectFit === "contain") return "object-contain";

  return "object-cover";
};
